import React from 'react'

class Child extends React.Component {
	render() {
return (
<div>

</div>
 	);
}
}

export default Child;
